module.exports = __webpack_public_path__ + "static/media/checked-img.47ac6f34.svg";